import { Image as ImageIcon } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";

import { ImagePlaceholderContainer } from "./ImagePlaceholderContainer";

export const ImagePlaceholder = () => (
    <ImagePlaceholderContainer>
        <ImageIcon
            size="xl"
            color={colorsPalettes.carbon[200]}
        />
    </ImagePlaceholderContainer>
);
